import parse from "html-react-parser";
import { cn } from "~/lib/utils";

type RichTextRendererProps = {
  richText: string;
  additionalClasses?: string;
};

export function RichTextRenderer({
  richText,
  additionalClasses,
}: RichTextRendererProps) {
  return (
    <div className={cn("list-styling rte-content", additionalClasses)}>
      {parse(richText)}
    </div>
  );
}
